import React from "react";
import env from "../env";

export default function LogoLoader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "2rem",
      }}
    >
      <img
        style={{
          width: "64px",
          height: "64px",
          display: "block",
          margin: "0 auto",
        }}
        src={`${process.env.REACT_APP_BUCKET_HOST}/${env.INSTANCE_ID}/icons/loading-spinner.png`}
        class="logo-flash"
      />
    </div>
  );
}
